import React from 'react';
import { motion } from '@/lib/motion';

export const PageHero = ({ 
  label, 
  title, 
  description, 
  backgroundImage,
  children 
}) => {
  return (
    <section 
      className="relative pt-24 pb-16 md:pt-40 md:pb-24 bg-obsidian overflow-hidden"
      data-testid="page-hero"
      aria-labelledby="page-hero-title"
    >
      {/* Background Image - More Visible */}
      {backgroundImage && (
        <div className="absolute inset-0">
          <img
            src={backgroundImage} 
            alt={`${typeof title === 'string' ? title : 'IHG Industry'} - Architectural Metalwork`}
            role="presentation"
            width={1920}
            height={800}
            loading="eager"
            decoding="async"
            fetchPriority="high"
            className="w-full h-full object-cover opacity-60"
          />
          {/* Lighter gradient overlay to show more of the image */}
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/50 to-obsidian/30" />
        </div>
      )}

      {/* Grid Pattern - Reduced opacity */}
      <div className="absolute inset-0 opacity-[0.015]">
        <div className="w-full h-full" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)',
          backgroundSize: '60px 60px'
        }} />
      </div>

      {/* Content - Center Aligned */}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="text-center"
        >
          {/* Label */}
          {label && (
            <div className="flex items-center justify-center gap-4 mb-4">
              <span className="w-8 h-px bg-bronze" />
              <span className="label-architectural text-white/50">{label}</span>
              <span className="w-8 h-px bg-bronze" />
            </div>
          )}

          {/* Title - Larger for better visibility */}
          <h1 
            id="page-hero-title"
            className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-5 drop-shadow-lg"
          >
            {title}
          </h1>

          {/* Description - Larger font */}
          {description && (
            <p className="font-body text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
              {description}
            </p>
          )}

          {/* Additional Content */}
          {children}
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-12 bg-gradient-to-t from-bronze to-transparent" />
    </section>
  );
};

export default PageHero;
